import {
  Control,
  Controller,
  FieldPath,
  FieldValues,
  PathValue,
  UseFormSetValue,
} from 'react-hook-form'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import useCourseThemes from '../hooks/use-course-themes'
import CourseThemeSelectItem from './course-theme-select-item'

type CourseThemeSelectProps<TValues extends FieldValues, TName extends FieldPath<TValues>> = {
  control: Control<TValues>
  setValue: UseFormSetValue<TValues>
  name?: TName
}

const CourseThemeSelect = <TValues extends FieldValues, TName extends FieldPath<TValues>>({
  setValue,
  control,
  name,
}: CourseThemeSelectProps<TValues, TName>) => {
  const { t } = useLocoTranslation()

  const { themes } = useCourseThemes()

  const selectName = name || ('theme' as TName)

  return (
    <Controller
      name={selectName}
      control={control}
      render={({ field: { value } }) => (
        <div
          className="customScroll grid max-h-[200px] gap-3 overflow-y-auto md:max-h-[350px] md:grid-cols-2"
          role="radiogroup"
          data-test-id="course-theme-select"
        >
          {themes?.map(theme => (
            <CourseThemeSelectItem
              key={`course-theme-${theme.id}`}
              theme={theme.colorSet}
              selected={value === theme.id}
              id={theme.id}
              onChange={id => setValue(selectName, id as PathValue<TValues, TName>)}
            />
          ))}
        </div>
      )}
    />
  )
}

export default CourseThemeSelect
